import apiFetech from "../configs/axios";
import { API_CITIES_URL, API_COUNTRIES_URL } from "../constants/urls";

export class CountriesServices { 
  /**
   *  Get All Countries
   * @returns {Array of Object}
   */
  static getAllCountries() {
    return apiFetech.get(API_COUNTRIES_URL);
  }

  /**
   *  Get All Cities
   * @returns {Array of Object}
   */
  static getAllCities() {
    return apiFetech.get(API_CITIES_URL);
  }

  static getCountry() {}
}
